<template>
  <div class="mediagallery media-gallery-dy mt-3 mb-1">
    <!-- <MediaCard :title="title" :duration="duration" /> -->
    <div class="gallery-item">
      <h3 class="media-gallery-title">{{title}}</h3> 
      <div class="album">
        <!-- <img src="https://placekitten.com/150/150" />
        <img src="https://placekitten.com/150/150" />
        <img src="https://placekitten.com/150/150" />
        <img src="https://placekitten.com/150/150" /> -->
       <!-- <div class="album-item"> <MediaCard :title="title" :duration="duration" /> </div>
       <div class="album-item"> <MediaCard :title="title" :duration="duration" /> </div>
       <div class="album-item"> <MediaCard :title="title" :duration="duration" /> </div>
       <div class="album-item"> <MediaCard :title="title" :duration="duration" /> </div> -->
       <div class="album-item" v-for="video in videos.slice(0,4)" :key="video.id">
         <MediaCard :title="video.title" :duration="video.time_duration"
              :img_src="video.cover_image.full_path" :media_type="media_type" />
        </div> 
      <b-badge variant="gallery" v-if="videos.length>4">+ {{videos.length-4}}</b-badge>
      </div>
    </div>
  </div>
</template>

<script>
import MediaCard from "./MediaCard.vue";

export default {
  name: "MediaGallery",
  components: { MediaCard },
  props: ["title", "videos","media_type"],
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doom_yoga/media/MediaGallery.vue